import { WizardStep } from '@app/components/wizard/wizard.component';
import { WizardSection } from '@app/models/project-setup.models';
import { StepSectionType } from './steps.enums';

export type StepsBySection = Map<StepSectionType, WizardStep<StepSectionType>>;

export const wizardStepMap = new Map<
  StepSectionType,
  Exclude<WizardSection, WizardSection.Base>
>([
  [StepSectionType.a, WizardSection.A],
  [StepSectionType.b, WizardSection.B],
  [StepSectionType.c, WizardSection.C],
  [StepSectionType.d, WizardSection.D],
  [StepSectionType.e, WizardSection.E],
  [StepSectionType.f, WizardSection.F],
  [StepSectionType.g, WizardSection.G],
  [StepSectionType.h, WizardSection.H],
  [StepSectionType.i, WizardSection.I],
  [StepSectionType.j, WizardSection.J],
]);
